
import Moment from 'moment';
import React, {useState} from 'react';


function SeceltaCommissione(props) {

  const [selContract, setSelContract] = useState(null);

  function handleChooseContract() {
    props.handleChooseContract(selContract);
  }

  function onContractChanged(e) {
    let selContract = props.user.user.commissionList.commissions.find(function (el) {
      return el.codComm === e.currentTarget.value;
    })
    setSelContract(selContract);
  }

  return (
      <div className="iol-checkout-left-part col-xl-7">
        <div className="iol-select-activity-wrapper row">
          <div className="iol-select-activity-title semibold">Seleziona tra le tue attività</div>
          {props.user &&  props.user.user && props.user.user.commissionList &&  props.user.user.commissionList.commissions  && props.user.user.commissionList.commissions.map((comm, index) => (
          <div className="iol-activity" key={comm.codComm}>
            <div className="iol-radio-activity" key={`1${comm.codComm}`}><input name="sceltaCommissione" className="iol-radio" type="radio" placeholder="c" value={comm.codComm} onChange={onContractChanged} key={comm.codComm}/></div>
            <div className="iol-activity-text" key={`2${comm.codComm}`}><label className="iol-activity-title semibold" htmlFor="azienda1" key={comm.codComm}>{comm.codComm}</label>
            <label className="iol-activity-address caption" htmlFor="azienda1" key={`3${comm.codComm}`}>Siglato il {Moment.unix(comm.signed/1000).format('DD/MM/YYYY HH:mm:ss')}</label></div>
          </div>
          ))}
        </div>
        <button className="fucsia-button semibold" type="submit" onClick={handleChooseContract}>Conferma e procedi</button>
       </div>
  );
}

export default SeceltaCommissione;
